import { __extends } from "tslib";
import React from 'react';
import { View, Image, TouchableHighlight, StyleSheet } from 'react-native';
// Custom
import c from '../styles/_colors.js';
import PnmacMobileCard from '../MobileCard';
import PnmacTextMobile from '../Typography/PnmacTextMobile';
var ErrorCard = /** @class */function (_super) {
  __extends(ErrorCard, _super);
  function ErrorCard(props) {
    var _this = _super.call(this, props) || this;
    _this.reportError = function () {
      _this.setState({
        show: true
      });
    };
    _this.state = {
      show: false
    };
    return _this;
  }
  ErrorCard.prototype.componentDidMount = function () {
    if (this.props.delayReporting) {
      this.delayedReporting = setTimeout(this.reportError, 150);
    } else {
      this.reportError();
    }
  };
  ErrorCard.prototype.componentWillUnmount = function () {
    clearTimeout(this.delayedReporting);
  };
  ErrorCard.prototype.render = function () {
    var _a = this,
      props = _a.props,
      state = _a.state;
    if (!state.show) return null;
    return /*#__PURE__*/React.createElement(PnmacMobileCard, null, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
      style: s.row
    }, /*#__PURE__*/React.createElement(Image, {
      source: require('../assets/error.png'),
      style: s.icon,
      resizeMode: "contain"
    }), /*#__PURE__*/React.createElement(PnmacTextMobile, {
      style: {
        flexShrink: 1
      }
    }, "There was a problem loading your account information")), /*#__PURE__*/React.createElement(TouchableHighlight, {
      onPress: props.onRefresh || props.onForceReload,
      style: [s.row, s.button],
      underlayColor: c.buttonActive
    }, /*#__PURE__*/React.createElement(PnmacTextMobile, {
      gilroy: true,
      darkerCyan: true,
      size: 15
    }, "Please try again"))));
  };
  return ErrorCard;
}(React.PureComponent);
export default ErrorCard;
var s = {
  row: {
    paddingHorizontal: 25,
    paddingVertical: 15,
    flexDirection: 'row',
    alignItems: 'center'
  },
  icon: {
    tintColor: c.red,
    width: 32,
    height: 28,
    marginRight: 20
  },
  button: {
    borderTopColor: c.whiteShade,
    borderTopWidth: StyleSheet.hairlineWidth,
    justifyContent: 'center'
  }
};